

// import UMUM from '../../library/umum'
import UMUM from '../library/umum'



export default {
    props: ['form'],
    data() {
        return {
            key: 'value',
            UMUM : UMUM,
        }
    },
}
